import React, { useEffect, useState } from 'react'
import { useParams, useLocation } from 'react-router-dom'

import { useTheme } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import moment from 'moment'

import Markdown from 'components/Markdown'
import SectionHeader from 'components/SectionHeader'
import { useNews } from 'hooks/useNews'

export default function NewsList({ limit }) {
  const { spacing, palette } = useTheme()
  const [item, setItem] = useState(null)
  const { id } = useParams()
  const location = useLocation()
  const { getNews } = useNews()

  useEffect(() => {
    getNews(id).then(setItem)
  }, [id, getNews])

  useEffect(() => {
    if (item && location.hash) {
      setTimeout(() => {
        const elementId = decodeURIComponent(location.hash.slice(1))
        const element = document.getElementById(elementId)
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
      }, 100)
    }
  }, [item, location.hash])

  if (!item) {
    return null
  }

  return (
    <div style={{ background: palette.background.paper, wordBreak: "break-all" }}>
      <SectionHeader primary="NEWS" />
      <div style={{ padding: spacing(3, 6) }}>
        <Typography style={{ marginBottom: spacing(1) }} variant="caption">
          {moment(item.publication_date).format('YYYY.MM.DD')}
        </Typography>
        <Typography style={{ marginBottom: spacing(3) }} variant="h3">
          {item.title}
        </Typography>
        <Markdown>{item.description}</Markdown>
      </div>
    </div>
  )
}
